import { client } from '@/services/api/axios.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TPlant } from '@/features/plants/schemas/plants.schema.ts';
import toast from 'react-hot-toast';
import { PowerSchedule } from '@/features/plants/schemas/schedule-plant.schema.ts';
import { AxiosError } from 'axios';

export const useCreateSchedulePlantMutation = ({ plantId }: { plantId?: string }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ schedule }: { schedule?: PowerSchedule }) => {
      if (!plantId || !schedule) return;

      const { data } = await toast.promise(
        async () =>
          await client.post<{ body: TPlant }>(`/plants/${plantId}/schedules`, {
            scheduleName: schedule.scheduleName,
            weeklySchedule: schedule.weeklySchedule,
            isActive: schedule.isActive,
          }),
        {
          loading: 'Creating schedule...',
          success: () => {
            return 'Successfully created the schedule.';
          },
          error: (
            error: AxiosError<{
              message: string;
            }>
          ) => {
            if (!error.response?.data?.message) {
              return `Uh oh, there was an error with creating the schedule.`;
            }

            return error.response?.data?.message;
          },
        }
      );

      return data?.body;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['plants', plantId, 'schedules'] });
    },
  });
};
